import { AudioPlayer, DefaultText, MusicNote, PopupConfirm, styleVariables } from '@lib/common';
import { Space } from 'antd';
import styled from 'styled-components';
import { CloseOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DEFAULT_ICON_SIZE = 24;
var StyledContainer = styled(Space).withConfig({
  displayName: "audio-file-editorcomponent__StyledContainer",
  componentId: "sc-1bq985h-0"
})(["padding:8px 16px;width:100%;border:1px solid ", ";border-radius:", ";"], styleVariables.colors.grey30, styleVariables.borderRadius.medium);
var StyledHorizontalContainer = styled.div.withConfig({
  displayName: "audio-file-editorcomponent__StyledHorizontalContainer",
  componentId: "sc-1bq985h-1"
})(["width:100%;display:flex;align-items:center;justify-content:space-between;gap:16px;"]);
var StyledInfo = styled(Space).withConfig({
  displayName: "audio-file-editorcomponent__StyledInfo",
  componentId: "sc-1bq985h-2"
})(["display:flex;gap:16px;align-items:center;"]);
var StyledAudioIconContainer = styled.div.withConfig({
  displayName: "audio-file-editorcomponent__StyledAudioIconContainer",
  componentId: "sc-1bq985h-3"
})(["display:flex;justify-content:center;align-items:center;background-color:", ";border-radius:", ";width:32px;height:32px;"], styleVariables.colors.primary20, styleVariables.borderRadius.medium);
var StyledActionContainer = styled.div.withConfig({
  displayName: "audio-file-editorcomponent__StyledActionContainer",
  componentId: "sc-1bq985h-4"
})(["display:flex;justify-content:center;align-items:center;gap:16px;"]);
var StyledHorizontalAudioPlayerContainer = styled.div.withConfig({
  displayName: "audio-file-editorcomponent__StyledHorizontalAudioPlayerContainer",
  componentId: "sc-1bq985h-5"
})(["flex:1;"]);
var StyleFileName = styled(DefaultText).withConfig({
  displayName: "audio-file-editorcomponent__StyleFileName",
  componentId: "sc-1bq985h-6"
})(["font-size:", ";"], styleVariables.font.fontSizeSmall);
var StyleFileSize = styled(StyleFileName).withConfig({
  displayName: "audio-file-editorcomponent__StyleFileSize",
  componentId: "sc-1bq985h-7"
})(["color:", ";"], styleVariables.colors.grey70);
export var AudioFileEditor = function AudioFileEditor(_ref) {
  var source = _ref.source,
      fileSize = _ref.fileSize,
      fileName = _ref.fileName,
      onDelete = _ref.onDelete,
      label = _ref.label;

  var renderContent = function renderContent() {
    return /*#__PURE__*/_jsxs(StyledHorizontalContainer, {
      children: [/*#__PURE__*/_jsxs(StyledInfo, {
        direction: 'horizontal',
        align: "center",
        children: [/*#__PURE__*/_jsx(StyledAudioIconContainer, {
          children: /*#__PURE__*/_jsx(MusicNote, {})
        }), /*#__PURE__*/_jsxs(StyleFileName, {
          children: [fileName, /*#__PURE__*/_jsxs(StyleFileSize, {
            children: [" | ", fileSize]
          })]
        })]
      }), /*#__PURE__*/_jsx(StyledHorizontalAudioPlayerContainer, {
        children: /*#__PURE__*/_jsx(AudioPlayer, {
          source: source
        })
      }), /*#__PURE__*/_jsx(StyledActionContainer, {
        children: onDelete && /*#__PURE__*/_jsx(PopupConfirm, {
          onConfirm: onDelete,
          okText: label.deleteOk,
          cancelText: label.deleteCancel,
          title: label.deleteTitle,
          children: /*#__PURE__*/_jsx(CloseOutlined, {
            color: styleVariables.colors.grey70,
            width: DEFAULT_ICON_SIZE
          })
        })
      })]
    });
  };

  return /*#__PURE__*/_jsx(StyledContainer, {
    direction: "vertical",
    children: renderContent()
  });
};